<template>
<div id="app">
  <div id="homeView" class="container-fluid">
    <div id="projectContainer" class="row">
      <div id="projectContainerText">
        <h2>Atlas Linguistique de la France</h2>
        <h6>- Projet ECLATS, ANR-15-CE-380002</h6>
        <h6>- Projet GeoDialect, Labex Persyval ANR-11-LABX-0025</h6>
        <h6>- Projet CartoDialect, CNRS PEPS interdisciplinaire « en réseau » HuMaIn 2013</h6>
      </div>
    </div>
  </div>
  <div id="homeText" class="container-fluid">
    <h1>CartoDialect</h1>
    <p id="accueilTitle" class="lead">Extraction d'informations sémantiques et géographiques à partir des données
      géolinguistiques</p>

    <div class='alert alert-danger'>
      <h4>Version 5 de cartodialect</h4>
      <ul id="versionAlert">
        <li>
          <p><strong>Attention</strong> : cette version béta n'a été testée que pour le navigateur Chrome, il se peut que
            pour d'autres navigateurs
            (firefox, Safari, Edge) certaines fonctionnalités d'annotations des cartes soient degradées.
          </p>
        </li>
      </ul>
    </div>

    <p style="text-align: justify">
      <a href="https://fr.wikipedia.org/wiki/Atlas_linguistique_de_la_France" target=_blank>L’Atlas Linguistique de la
        France (ALF) </a> a été réalisé par Jules Gilliéron et Edmond Edmont. Entre 1897 et 1901
      Edmond Edmont a effectué des enquêtes de terrain dans 638 communes de la France. Pour ce faire, il a utilisé un
      questionnaire
      composé de notions qu’il a posé auprès de 735 informateurs. Les données dialectales recueillies ont été publiées
      sous la forme de cartes qui comportent 639 numéros de points d’enquêtes. Chaque réponse dialectale (retranscrite
      avec l’alphabet phonétique Rousselot-Gilliéron) figure à côté ou en dessous du numéro de point d’enquête. En
      tout,
      ce sont 1920 cartes (1421 cartes complètes, 326 demi-cartes et 173 quarts) qui ont été classées par ordre
      alphabétique
      des notions et publiées entre 1902 et 1910, d'abord sous forme de fascicules, puis sous la forme de volumes. Ces
      cartes permettent d’étudier les variations lexicales gallo-romanes au début du XXe siècle et les données
      géolinguistiques
      qu'elles contiennent sont utilisées pour élaborer des atlas interprétatifs.
    </p>
    <p style="text-align: justify">
      Les Projets Exploratoires
      <a href="https://persyval-lab.org/en/exploratory-project/GeoDialect" target=_blank>GeoDialect</a> et
      <a href="http://www.gipsa-lab.grenoble-inp.fr/recherche/projets.php?id_projet=201" target=_blank>Cartodialect</a> financés respectivement par le Labex Persyval et la mission
      inter-disciplinaire du CNRS, se sont
      intéressés à la fois à l’exploration des outils géomatiques pour le traitement et l'analyse des données
      géolinguistiques
      et à la définition de méthodes et d’outils facilitant l’extraction automatique des données sémantiques et
      géographiques
      contenues dans les cartes de l’ALF. La mise à disposition des cartes de l’ALF en version numérique s’inscrit
      dans
      le cadre de cette recherche qui se poursuit à travers le projet ANR
      <a href="http://eclats.imag.fr" target=_blank>ECLATS</a>.
    </p>

    <p style="text-align: justify">
      Ce site vous permet de
      <a href="visualiseur">visualiser</a> et de
      <a href="listeCartes">télécharger</a> les cartes de l'Atlas linguistique de la France. Vous pouvez également
      rechercher une carte par notion
      associée, ou par son numéro (le numéro attribué par l'ALF).
    </p>
    <p>
      Ce projet est financé par :
    </p>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-4 droite">
          <a href="http://www.cnrs.fr" target=_blank>
            <img src="../../assets/logos/logoCnrs.jpg" alt="logo CNRS" class="img-fluid" />
          </a>
        </div>
        <div class="col-sm-4 centre">
          <br>
          <a href="https://persyval-lab.org/" target=_blank>
            <img src="../../assets/logos/logoPersyval.jpg" alt="logo Persyval" class='img-fluid' />
          </a>
          <br>
          <br>
        </div>
        <div class="col-sm-4 gauche">
          <a href="http://www.agence-nationale-recherche.fr" target=_blank>
            <img src="../../assets/logos/logoANR.png" alt="logo ANR" class="img-fluid" />
          </a>
        </div>
      </div>
    </div>
    <p>
      <br>
    </p>
  </div>
</div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style>
#projectContainer {
  position: fixed;
  top: 57px;
  color: #800000;
  background: url('../../assets/fondHead.png');
  padding-bottom: 5px;
  padding-right: 10px;
  padding-left: 10px;
  width:100%;
  z-index: 100000;
}

#projectContainerText {
  text-align: left;
  padding: 5px;
}

.container-fluid > h1, h4, #accueilTitle {
  padding-top: 20px;
  text-align: left;
}

#versionAlert {
  text-align: left;
}

#homeText {
  margin-top: 200px;
}

</style>


// WEBPACK FOOTER //
// src/components/layout/Home.vue